import {RouteRecordRaw} from 'vue-router';

export const landingRoutes: RouteRecordRaw = {
  path: '/landing',
  name: 'Landing',
  meta: {requiresAuth: false},
  component: () => import('@/features/landing/views/Landing.vue'),
};
